import React from "react";

type EventDescriptionProps = {
  text: string;
};

// Matches: Title(https://example.com)
const linkPattern = /([A-Za-z0-9 _.,!?'’+-]+)\((https?:\/\/[^)]+)\)/g;


export const EventDescription: React.FC<EventDescriptionProps> = ({ text }) => {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = linkPattern.exec(text)) !== null) {
    const [fullMatch, title, href] = match;
    const matchStart = match.index;

    // Add plain text before the match
    if (matchStart > lastIndex) {
      parts.push(text.slice(lastIndex, matchStart));
    }

    // Add the hyperlink
    parts.push(
      <a
        key={parts.length}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {title}
      </a>
    );

    lastIndex = matchStart + fullMatch.length;
  }

  // Add remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return (
    <div>
      <p>{parts}</p>
    </div>
  );
};